import styled from 'styled-components';
import Theme from '../../styles/models/theme';

export const Container = styled.div<{theme: Theme}>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.lightBackground};
  text-align: center;
  padding: 25px;
`;

export const Title = styled.h1<{theme: Theme}>`
  margin-top: 15px;
  font-weight: bold;
  font-size: 35px;
  line-height: 37px;
  color: ${({theme}) => theme.secondary};
  margin-bottom: 30px;
`;

export const Text = styled.p<{theme: Theme}>`
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  color: ${({theme}) => theme.secondary};
  text-align: left;
`;

export const TermsContainer = styled.div`
  text-align: left;
  margin-top: 25px;
  margin-bottom: 25px;
`;
